import italic from "./assets/fonts/Instrument_Serif/InstrumentSerif-Italic.woff2" with {
  type: "file",
};
import regular from "./assets/fonts/Instrument_Serif/InstrumentSerif-Regular.woff2" with {
  type: "file",
};

/**
 * Instrument Serif, registered from JavaScript rather than from an `@font-face`
 * in global.css — and that is a workaround, so it needs its reason on the file.
 *
 * Bun's CSS bundler inlines every `url()` it can resolve, with no threshold and
 * no way to opt out. Both faces as base64 took the one render-blocking
 * stylesheet from **7.3 KB to 62 KB gzipped**, on all four pages, for a typeface
 * only /live uses. Measured, not assumed.
 *
 * Imported `with { type: "file" }` the bundler copies and content-hashes them
 * instead and hands back a URL, which is the same trick the tour dates iframe
 * used before ticket 032 deleted it. `FontFace` then registers them at runtime.
 * Two cacheable requests that start when the app boots and block nothing.
 *
 * If Bun ever gains a way to keep a CSS `url()` out of the stylesheet, this file
 * should go back to being two `@font-face` rules in global.css.
 */

const FACES = [
  { src: regular, style: "normal" },
  { src: italic, style: "italic" },
];

let loaded = false;

/**
 * Registers both faces. Safe to call more than once, and a no-op anywhere there
 * is no document — `renderToStaticMarkup` in the test suite reaches this module
 * through the component tree.
 */
export function loadFonts(): void {
  if (loaded) return;
  if (typeof document === "undefined" || !document.fonts) return;
  loaded = true;

  for (const face of FACES) {
    const font = new FontFace("Instrument Serif", `url(${face.src}) format("woff2")`, {
      style: face.style,
      weight: "400",
      // The panel is legible in the fallback serif, so a swap beats a blank slot.
      display: "swap",
    });
    // `add` before `load`: the face is then in the document's set and the browser
    // fetches it when something actually needs it, rather than us forcing both
    // down the wire on a page that may never show them.
    document.fonts.add(font);
  }
}
